import { CollectionRepository, Id } from '../abstraction';
import { toIdString } from '../functions/to-id-string';
import { IndexedDbDataAccess } from '../../data-access/indexed-db.data-access';
import { ReadonlyIndexedDbCollectionRepository } from './readonly-indexed-db-collection.repository';
import { Dictionary } from '../../types/dictionary';

export abstract class IndexedDbCollectionRepository<TItem, TParams extends Dictionary<unknown> | undefined> extends ReadonlyIndexedDbCollectionRepository<TItem, TParams> implements CollectionRepository<TItem, TItem[], TItem, TParams, TParams> {

  protected constructor(dataAccess: IndexedDbDataAccess,
                        databaseName: string,
                        objectStoreName: string) {
    super(dataAccess, databaseName, objectStoreName);
  }

  async create(value: TItem, params: TParams): Promise<TItem> {
    const id = this.getId(value)
    const location = {
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      key: toIdString(id),
      params
    };
    return await this.dataAccess.add(location, value);
  }
  async update(id: Id, value: TItem, params: TParams): Promise<TItem> {
    const location = {
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      key: toIdString(id),
      params
    };
    return await this.dataAccess.put(location, value);
  }
  async patch(id: Id, changes: Partial<TItem>, params: TParams): Promise<TItem> {
    const location = {
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      key: toIdString(id),
      params
    };
    const item = await this.dataAccess.get<TItem>(location);
    const newItem = {...item, ...changes}
    return await this.dataAccess.put(location, newItem);
  }
  async delete(id: Id, params: TParams): Promise<TItem> {
    const location = {
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      key: toIdString(id),
      params
    };
    return await this.dataAccess.delete(location);
  }

  abstract getId(value: TItem): Id
}
